/**
 * Menu select drop mock
 */

// Utils
import { MenuItems, MenuItemValue, OptionValue } from 'utils/types';
import { OptionBulkOperations, VALUE_MENU } from 'utils/constants';

// Router
import ROUTES from 'configs/route';

export const menuItems: MenuItems<MenuItemValue> = [
  { value: VALUE_MENU.USER_INFO, content: 'おもたす登録者情報', href: ROUTES.USER_INFO },
  { value: VALUE_MENU.DIGITAL_SURVEY, content: 'デジタルアンケート', href: ROUTES.DIGITAL_SURVEY },
  // No data
  { value: VALUE_MENU.PEOPLE_MEASUREMENT, content: '人流計測', href: ROUTES.PEOPLE_MEASUREMENT },
  { value: VALUE_MENU.AUDIO_ANALYSIS, content: '音声解析', href: ROUTES.AUDIO_ANALYSIS },
  // { value: 'document_request_form, content: '資料請求フォーム' },
  {
    value: VALUE_MENU.APPLICATION_STATUS_CHECK,
    content: '申請状況確認',
    href: ROUTES.SYSTEM_APPLICATION_STATUS_CHECK,
  },
  {
    value: VALUE_MENU.SYSTEM_SETTING,
    content: 'システム設定',
    href: ROUTES.SYSTEM_APPLICATION_SETTING,
  },
];

export const systemUsageStatus: MenuItems<any> = [
  { value: 'all', content: '利用中/終了' },
  { value: 1, content: '利用中' },
  { value: 2, content: '終了' },
];

export const systemUsageDigitalStatus: MenuItems<any> = [
  { value: undefined, content: '利用中/終了' },
  { value: 'in-used', content: '利用中' },
  { value: 'finished', content: '終了' },
];

export const optionApplicationCheck: MenuItems<OptionValue> = [
  { value: OptionBulkOperations.DEFAULT, content: '一括操作', disable: true },
  { value: OptionBulkOperations.APPROVAL, content: '承認' },
  { value: OptionBulkOperations.DISAPPROVAL, content: '非承認' },
];

export const systemName: MenuItems<any> = [
  { value: 'all', content: '全て' },
  { value: 1, content: 'デジタルアンケート' },
  { value: 2, content: '人流計測' },
  { value: 3, content: '音声解析' },
  { value: 4, content: '資料請求フォーム' },
];
